import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 0 },
    rootMargin: { type: String, default: '0px 0px -80px 0px' },
  };

  connect() {
    if (this.skipsAnimation) {
      this.reveal();
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!this.shouldReveal(entry)) return;

        this.element.style.transitionDelay = `${this.delayValue}ms`;
        this.reveal();
        this.observer.disconnect();
      },
      { rootMargin: this.rootMarginValue }
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  // A fast scroll can carry the element past the viewport between two frames.
  shouldReveal(entry) {
    const rootTop = entry.rootBounds ? entry.rootBounds.top : 0;

    return entry.isIntersecting || entry.boundingClientRect.top < rootTop;
  }

  get skipsAnimation() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  reveal() {
    this.element.classList.add('is-revealed');
  }
}
